import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgGroeneOmgeving = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#85E3F9"
      d="M18 20h3v12h-3z"
    />
    <path
      fill="#00C5F2"
      fillRule="evenodd"
      d="M26 14.035V14a6 6 0 0 0-12 0v.036a3.5 3.5 0 1 0 0 6.93v.034h11v-.035q.245.035.5.035a3.5 3.5 0 0 0 .5-6.965M17.057 28.429v.685l.414-.391.009-.008a1.52 1.52 0 0 1 2.096.02 1.39 1.39 0 0 1-.02 2.02L18.237 32h-5.476l-1.318-1.245a1.39 1.39 0 0 1-.02-2.02 1.52 1.52 0 0 1 2.097-.02l.008.008.563.532v-.827c0-.788.664-1.428 1.483-1.428.818 0 1.482.64 1.482 1.429"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgGroeneOmgeving);

export default ForwardRef;
